import { SubscriptionTab } from "contexts/Subscription";
import { Subscription, SubscriptionType } from "schemas/dashboard";
import { Plans, getEquivalentPlansFromOverride } from "schemas/payments";

import { titleCase } from "utils/string";

export const disabledCurrentPlan = (
  plan: Plans,
  subscription: Subscription | null,
) => {
  if (plan === Plans.FREE) return true;
  if (subscription?.overridePlanName) {
    return getEquivalentPlansFromOverride(
      subscription.overridePlanName,
    )?.includes(plan);
  }
  return false;
};

export const getCurrentPlanButton = (
  plan: Plans,
  subscription: Subscription | null,
) => {
  const isButtonDisabled = disabledCurrentPlan(plan, subscription);
  if (isButtonDisabled) {
    return "Current Plan";
  } else if (subscription?.subscription?.status === SubscriptionType.CANCELED) {
    return "Resubscribe";
  } else if (
    subscription?.subscription.cancelAt &&
    subscription?.subscription?.status === SubscriptionType.ACTIVE
  ) {
    return "Renew Subscription";
  } else if (
    subscription?.subscription?.status === SubscriptionType.INCOMPLETE ||
    subscription?.subscription?.status === SubscriptionType.INCOMPLETE_EXPIRED
  ) {
    return "Retry";
  } else {
    return "Manage Current Plan";
  }
};

export const getOtherPlanButton = (tier: Plans, userCurrentPlan?: Plans) => {
  const orders = {
    [Plans.FREE]: 0,
    [Plans.STARTER]: 1,
    [Plans.STARTER_YEARLY]: 1,
    [Plans.PRO]: 2,
    [Plans.PRO_YEARLY]: 2,
    [Plans.VA]: 3,
    [Plans.VA_YEARLY]: 3,
  };
  if (userCurrentPlan && orders[userCurrentPlan] >= orders[tier]) {
    return "Choose This Plan";
  } else {
    return "Upgrade";
  }
};

export const getStatusChipLabel = (status?: SubscriptionType) => {
  if (status === SubscriptionType.TRIALING) {
    return "Active";
  } else if (status === SubscriptionType.INCOMPLETE) {
    return "Failed Payment";
  } else {
    return titleCase(status || "");
  }
};

export const isCurrentPlan = (
  subscription: Subscription | null,
  plan: Plans,
) => {
  return (
    subscription?.subscription?.planName === plan ||
    (subscription?.subscription?.planName === Plans.STARTER_YEARLY &&
      plan === Plans.PRO_YEARLY) ||
    (subscription?.subscription?.planName === Plans.STARTER &&
      plan === Plans.PRO)
  );
};

export const isOnFreePlan = (subscription: Subscription | null) => {
  return (
    !subscription || !subscription.subscription || !subscription?.isSubscribed
  );
};

export const PaidAccessFeatures = [
  "Restricted Filtering Feature",
  "Reply Score",
  "Exclusive Contact",
  "Access Partnership Data",
];

export const DisplayOnlyPartnershipsAddon = [
  "Reply Score",
  "Access Partnership Data",
];

export const getAllPlans = (
  tab: SubscriptionTab,
  upgradeDialogSource?: string,
  currentPlan?: Plans,
) => {
  if (tab === SubscriptionTab.yearly) {
    if (
      upgradeDialogSource === "Upgrade VA Button" ||
      upgradeDialogSource === "Upgrade Offer Dialog" ||
      (upgradeDialogSource === "Upgrade from Tier Metrics" &&
        (currentPlan === Plans.PRO || currentPlan === Plans.PRO_YEARLY))
    ) {
      return [Plans.VA_YEARLY];
    } else if (upgradeDialogSource) {
      return [Plans.PRO_YEARLY, Plans.VA_YEARLY];
    }
    const yearly = [Plans.FREE, Plans.PRO_YEARLY, Plans.VA_YEARLY];
    return yearly;
  } else {
    if (
      upgradeDialogSource === "Upgrade VA Button" ||
      upgradeDialogSource === "Upgrade Offer Dialog" ||
      (upgradeDialogSource === "Upgrade from Tier Metrics" &&
        (currentPlan === Plans.PRO || currentPlan === Plans.PRO_YEARLY))
    ) {
      return [Plans.VA];
    }
    if (upgradeDialogSource) {
      return [Plans.PRO, Plans.VA];
    }
    const monthly = [Plans.FREE, Plans.PRO, Plans.VA];
    return monthly;
  }
};
